module.exports = {"oops":"Lỗi...","oopsTitle":"Đã có lỗi xảy ra","notFound":"Không tìm thấy","status":{"400":"Lỗi kết nối đến Cơ Quan Thuế, vui lòng thử lại sau vài giây!","401":"Thông tin đăng nhập không chính xác.","default":"Lỗi kết nối đến Cơ Quan Thuế, vui lòng thử lại sau vài giây!"},"form":{"email":{"required":"Email là bắt buộc.","validate":"Thông tin không hợp lệ tại email thứ "},"taxCode":{"validate":"Định dạng mã số thuế không hợp lệ"}},"company":{"update":{"400":"Thông tin doanh nghiệp đã tồn tại trên hệ thống.","default":"Lỗi xảy ra khi cập nhật."}}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/vi/error.json
// module id = vpbD
// module chunks = 23